import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATA_SOURCES_CUSTOM_STATE_NAME, DataSourcesCustomState} from "./dataSourcesCustom";
import {DatasetUsageComponentObjects} from '../../classes/dataset-usage-component-object';
import {Serializers} from '../../interfaces/serializer';
import {DataSource} from '../../interfaces/data-source';
import {CustomImport} from "../../interfaces/custom-import";

export const selectDataSourcesCustomsState: MemoizedSelector<object, DataSourcesCustomState> = createFeatureSelector<DataSourcesCustomState>(DATA_SOURCES_CUSTOM_STATE_NAME);

export const selectDataSourcesCustom: MemoizedSelector<object, Serializers<DataSource>> = createSelector(
  selectDataSourcesCustomsState,
  (dataSourcesCustomState: DataSourcesCustomState) => dataSourcesCustomState.serialized
);

export const selectDataSourcesCustomImports: MemoizedSelector<object, Serializers<CustomImport>> = createSelector(
  selectDataSourcesCustomsState,
  (dataSourcesCustomState: DataSourcesCustomState) => dataSourcesCustomState.imports
);

export const selectDataSourceCustomComponentObjects: MemoizedSelector<object, DatasetUsageComponentObjects> = createSelector(
  selectDataSourcesCustomsState,
  (dataSourcesCustomState: DataSourcesCustomState): DatasetUsageComponentObjects => dataSourcesCustomState.componentObjects
);

export const selectDataSourcesCustomsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesCustomsState,
  (dataSourcesCustomState: DataSourcesCustomState): boolean => dataSourcesCustomState.loading
);
